<template>
    <v-dialog
        ref="dialog"
        v-model="dialogOpen"
        persistent
        width="290px"
    >

        <template v-slot:activator="{ on, attrs }">
            <v-slide-x-transition>
                <v-text-field
                    :value="formattedValue"
                    :persistent-hint="true"
                    readonly
                    v-bind="{...$attrs,...attrs}"

                    v-on="on"
                ></v-text-field>
            </v-slide-x-transition>
        </template>
        <v-date-picker
            v-model="model_local"
            :allowed-dates="$attrs.allowedDates"
            @input="save"
            scrollable
            range
        >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="close"
            >
                Cancel
            </v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
import WithValidation from "./WithValidation";
import moment         from 'moment';

export default {
    name      : "VVRangeDatepickerDialog",
    components: {WithValidation},
    props     : ['field', 'value', 'title'],
    data      : () => ({
        dialogOpen: false,
        model_local: [
            null,
            null
        ]
    }),
    methods   : {
        save() {
            this.$emit('input', this.model_local);
            if (this.model_local[0] && this.model_local[1]) {
                this.close();
            }
        },
        close() {
            this.dialogOpen = false;
            this.$emit('blur');
        }
    },
    computed  : {
        formattedValue() {
            let val = '';
            if (this.model_local[0]) {
                let dateStart = moment(this.model_local[0]);
                if (dateStart.isValid()) {
                    val += dateStart.format(this.dateFormat);
                }
            }
            if (this.model_local[0] || this.model_local[1])
                val += ' - ';
            if (this.model_local[1]) {
                let dateEnd = moment(this.model_local[1]);
                if (dateEnd.isValid()) {
                    val += dateEnd.format(this.dateFormat);
                }
            }
            return val;
        },
        dateFormat() {
            return this.$store.state.config.dateFormat;
        }
    }
}
</script>

<style scoped>

</style>
